import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  EXPLORE: {
    id: 'Explore.explore',
    defaultMessage: 'Explore',
    description: '[Type: Label][Vis.: low] - Explore link in main navigation',
  },
});

const Explore = () => {
  const url = createURL('/apps/', { ut_source: 'header' });
  const title = t(COPY.EXPLORE);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.EXPLORE} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.EXPLORE} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default Explore;
export { Explore };
